<template>
    <div>
        <a-t-list
            modal-title="Novo Orçamento"
            name="Orçamento"
            plural-name="Orçamentos"
            fetch-url="budget"
            fetch-trashed-url="budget/trashed"
            save-url="budget"
            entity-search-url="client/search/"
            entity-name="Cliente"
            madeByLabel="Vendedor"
            :article-transaction-type="Global.ARTICLE_TRANSACTION_BUDGET"
            :has-discount="true"
            :defaultSituationId="Types.sell_situation.EM_ANDAMENTO"
        ></a-t-list>
    </div>
</template>

<script>
    import ATList from '../article_transaction/ATList';
    import {Global, Types} from "../../config";

    export default {
        name: "Budgets",
        data(){
            return {
                Global,
                Types,
            }
        },

        components: {
            ATList,
        },

        methods: {

        },

        computed: {

        }
    }
</script>

<style scoped>

</style>